/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_Force_End_Error_Has_In_DeliveryInputs */

const vi_trip_force_end_error_has_in_delivery = /** @type {(inputs: Trip_Force_End_Error_Has_In_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyến còn đơn đang giao — hãy nghị quyết từng đơn trong hộp thoại trước khi kết thúc chuyến`)
};

/**

* @param {Trip_Force_End_Error_Has_In_DeliveryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_force_end_error_has_in_delivery = /** @type {((inputs?: Trip_Force_End_Error_Has_In_DeliveryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_Force_End_Error_Has_In_DeliveryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_force_end_error_has_in_delivery(inputs)
});